import React, { PureComponent } from 'react';


class RadioButtonParticularGeographicCode extends PureComponent {

    render() {

        const { GET_CODIGO_GEOGRAFICO, Validaciones, ValidarPantalla, Cuenta, form, domicilio, tipoDomicilio, guardarCampoCuenta } = this.props;
        const codigoGeografico = Cuenta.DomicilioParticularCodigoGeografico;
        const desactivarInput = (codigoGeografico != "0");
        const me = this;

        let radioCodigoGeo = null;
        let codigos;

        if (GET_CODIGO_GEOGRAFICO) {
            const codigoElements = GET_CODIGO_GEOGRAFICO.filter(c => c.CodigoPostal == domicilio.Direccion.CodigoPostal);

            codigos = JSON.parse(JSON.stringify(codigoElements));
            codigos.push({ Id: 0, CodigoGeografico: "0" });

            radioCodigoGeo = codigos.map((codigo, index) => {
                const estaSeleccionado = (codigo.CodigoGeografico == codigoGeografico)

                if (codigo.CodigoGeografico == "0") {
                    return (
                    <div className="col-xs-5" key={"div-codigo-geo-" + index}>
                        <div className="col-xs-6">
                            <div className="container-radio radio-margin">
                                <input value="0" type="radio" name="codigo-part-geografico"
                                    id={"codigo-part-geografico-" + index} checked={estaSeleccionado}
                                    onChange={() => { guardarCampoCuenta("0", "DomicilioParticularCodigoGeografico") }} />

                                <label className="lbl-radio label-secondary" htmlFor={"codigo-part-geografico-" + index}>Otro</label>
                            </div>
                        </div>
                        <div className="col-xs-6">
                            <input value={Cuenta.DomicilioParticularCodigoGeograficoInput} type="text"
                                className="form-control default-input" maxLength="5" disabled={(desactivarInput)}
                                onChange={(event) => { guardarCampoCuenta(event.target.value, "DomicilioParticularCodigoGeograficoInput") }} />
                        </div>
                    </div>
                    );
                } else {
                    return (
                    <div className="col-md-2" key={"div-codigo-geo-" + index}>
                        <div className="container-radio radio-margin">
                            <input value={codigo.CodigoGeografico} type="radio" name="codigo-part-geografico"
                                id={"codigo-part-geografico-" + index} checked={estaSeleccionado}
                                onChange={(event) => { guardarCampoCuenta(event.target.value, "DomicilioParticularCodigoGeografico") }} />

                            <label className="lbl-radio label-secondary" htmlFor={"codigo-part-geografico-" + index}>{codigo.CodigoGeografico}</label>
                        </div>
                    </div>
                    );
                }
            });
        }

        let mensajeError = null;
        if (ValidarPantalla == true) {
            if (Validaciones.CodigoGeograficoParticularSeleccionado == false) {
                mensajeError = <label className="error">Debe seleccionar un código geografico</label>;
            }
        }

        return (
        <div>
            <div className="row">
                <div className="col-xs-12">
                    <h5>{"Código geográfico para " + domicilio.Direccion.Localidad}</h5>
                </div>
            </div>
            <div className="row">
                <div className="col-xs-8">
                    {radioCodigoGeo}
                </div>
                <div className="col-xs-12">
                    {mensajeError}
                </div>
            </div>
        </div>
        );

    }

}

export default RadioButtonParticularGeographicCode;